import apiClient from '../api';

export async function reserveGoogle(sku) {
  try {
    await apiClient.post('/googlemaps/reserve', { sku });
    return true;
  } catch (err) {
    if (err?.response?.status === 429 || !err?.response) return false;
    return false;
  }
}
